var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"appbg"}},[_c('vue-confirm-dialog'),_c('navbar'),_c('br'),_c('br'),_c('br'),_c('br'),_c('main',{staticClass:"py-4"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }